export const APPROVAL_STATUS_OPTIONS = [
  { value: 'missing', label: 'Fehlt', color: 'error' },
  { value: 'requested', label: 'Beantragt', color: 'warning' },
  { value: 'approved', label: 'Genehmigt', color: 'success' },
  { value: 'rejected', label: 'Abgelehnt', color: 'error' },
  { value: 'expired', label: 'Abgelaufen', color: 'default' },
  { value: 'not_required', label: 'Nicht erforderlich', color: 'info' }
];

export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'incomplete', label: 'Unvollständig', color: 'warning' },
  { value: 'complete', label: 'Vollständig', color: 'success' },
  { value: 'expired', label: 'Abgelaufen', color: 'error' }
];

export const BILLING_STATUS_OPTIONS = [
  { value: 'not_ready', label: 'Nicht bereit', color: 'default' },
  { value: 'ready', label: 'Bereit', color: 'success' },
  { value: 'exported', label: 'Exportiert', color: 'info' },
  { value: 'submitted', label: 'Eingereicht', color: 'primary' },
  { value: 'paid', label: 'Bezahlt', color: 'success' },
  { value: 'rejected', label: 'Beanstandet', color: 'error' }
];

export const TREATMENT_TYPE_OPTIONS = [
  { value: 'dialysis', label: 'Dialyse' },
  { value: 'chemo', label: 'Chemo' },
  { value: 'radiation', label: 'Bestrahlung' },
  { value: 'rehab', label: 'Reha' },
  { value: 'therapy', label: 'Therapie' },
  { value: 'doctor', label: 'Arzttermin' },
  { value: 'other', label: 'Sonstiges' }
];

export const ROUTE_SCOPE_OPTIONS = [
  { value: 'fixed_route', label: 'Feste Strecke' },
  { value: 'facility_only', label: 'Feste Einrichtung' },
  { value: 'flexible', label: 'Flexibel' }
];

export const COPAYMENT_STATUS_OPTIONS = [
  { value: 'unknown', label: 'Unbekannt' },
  { value: 'exempt', label: 'Befreit' },
  { value: 'required', label: 'Zuzahlung erforderlich' },
  { value: 'collected_elsewhere', label: 'Anderweitig geklärt' }
];

export const getOption = (options, value) =>
  options.find(option => option.value === value) || options[0];

export const toDateInputValue = (value) => {
  if (!value) return '';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

export const formatDate = (value) => {
  if (!value) return 'Nicht gesetzt';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Nicht gesetzt';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
};
